// Extracted JavaScript from page.shipment-details.liquid
// Customer ID and other Liquid variables are passed via window.shipmentDetailsData



// ===== MAIN SCRIPT BLOCK =====

dataLayer.push({
    event: "select_shipment",
  });
  clevertap.event.push("select_shipment");
let order_cof_id = 0;
let textareaValue = '';
function cancelOrder() {
const context = window.sessionCore.getMergedContext();
const params = new URLSearchParams(window.location.search);
const locationData = window.getLocationData();
const orderId = params.get('orderId');
 document.querySelector('.cancel-full-scr').style.display = "block";
 document.querySelector('body').style.overflow = "hidden";
 analytics.track("Order Cancellation Intiated", {
  "order_id": orderId,
  "platform": "web",
  "user_id": window.shipmentDetailsData?.customerId || null,
  ...(locationData && {
    user_location: locationData
  }),
  ...context
})
}
function cancelOrderClose() {
document.querySelector('.cancel-full-scr').style.display = "none";
document.querySelector('body').style.overflow = "auto";
document.getElementById('active-button').classList.remove('clicked-style');
document.getElementById('active-button').disabled = false;
document.querySelector('.yes-cancel').style.opacity = "0.5";
document.querySelector('.yes-cancel').style.pointerEvents = "none";
document.querySelector('.dont-cancel').style.opacity = "0.5";
document.querySelector('.dont-cancel').style.pointerEvents = "none";
document.querySelector('.text-area-cancel').style.display = "none";
const textArea = document.querySelector('.textarea-container textarea');
if (textArea) {
  textArea.value = '';
} 
}   
function cancelnextopen() {
document.querySelector('.cancel-full-scr-div').style.display = "none";
document.querySelector('.cancel-next-full').style.display = "block";
document.querySelector('body').style.overflow = "hidden";


}   
function cancelnextclose() {
document.querySelector('.cancel-full-scr').style.display = "none";
document.querySelector('.a-box').style.overflow = "auto";
document.querySelector('.post_cancel_div').style.display = "block"; 
document.querySelector('.delivery-status').style.display = "none";
document.querySelector('.payment-container').style.display = "none";               
document.querySelector('.cancel-lower-cont').style.display = "none";
document.querySelector('.cancel-next-full').style.display = "none";  
}
function viewSummary() {
document.querySelector(".view-item-modal").style.display = "block";
document.body.style.overflow = "hidden";
}
function closeViewSummary() {
document.querySelector(".view-item-modal").style.display = "none";
document.body.style.overflow = "auto";
}
window.addEventListener("click", function(event) {
const modal = document.querySelector(".view-item-modal");
const modalContent = document.querySelector(".view-item-modal-div");

if (event.target === modal) {
  modal.style.display = "none";
  document.body.style.overflow = "auto";
}
});  
function submitCancellation() {
const activeButton = document.getElementById('active-button');
if (activeButton) {
let reason = activeButton.textContent.trim();
let textareaValue = '';  
if (reason === "Others") {
   textareaValue = document.querySelector('.textarea-box').value;
   document.querySelector('.text-area-cancel').style.display = "block";
}        
const requestBody = {
   "orderId": order_cof_id,
   "reason": reason,
   "comments": textareaValue
}; 
fetch("https://supertails-backend.el.r.appspot.com/order/cancel-web-order", {
   method: 'POST',
   headers: {
       'Content-Type': 'application/json',
   },
   body: JSON.stringify(requestBody)
})
.then(response => {
   if (!response.ok) {
       throw new Error('Network response was not ok');
   }
   return response.json();
})
.then(result => {
   const context = window.sessionCore.getMergedContext();
   const locationData = window.getLocationData();
     analytics.track("Order Cancelled", {
        "order_cancellation_reason": [
           {
              "reason": reason || null,
           }
        ],
        "order_id": order_cof_id || null,
        "platform": "web",
        "user_id": window.shipmentDetailsData?.customerId || null,
        ...(locationData && {
          user_location: locationData
        }),
        ...context
        })
})
.catch(error => {
   console.error("Error during cancellation:", error);
});
} else {
alert("Please select a reason for cancellation.");
}
}
function createImageIcon(src) {
let img = document.createElement('img');
img.src = src; 
img.alt = "Icon"; 
img.width = 24; 
img.height = 24;
return img;
}
function getParameterByName(name, url = window.location.href) {
name = name.replace(/[\[\]]/g, '\\$&');
const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
     results = regex.exec(url);
return results ? decodeURIComponent(results[2].replace(/\+/g, ' ')) : null;
}

const orderId1 = getParameterByName('orderId');
const awb1 = getParameterByName('awb');
const skus1 = getParameterByName('skus');
const currentShipment = getParameterByName('currenS');
const totalShipments = getParameterByName('totalS');

const returnRequestId = getParameterByName('returnRequestId') ?? '';
const deliverytText = `Delivery ${currentShipment} of ${totalShipments}`;

const placedorder= 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/placed-icon.png?v=1729084758';
const shippedorder = `https://cdn.shopify.com/s/files/1/0565/8021/0861/files/shipped-icon.png?v=1729084730`;
const ofd= `https://cdn.shopify.com/s/files/1/0565/8021/0861/files/ofd-icon.png?v=1729084743`;
const ReturnRequest = `https://cdn.shopify.com/s/files/1/0565/8021/0861/files/return-request.png?v=1731737413`;
const ReturnApproved = `https://cdn.shopify.com/s/files/1/0565/8021/0861/files/request-approved.png?v=1731737438`;
const ReturnPickedup = `https://cdn.shopify.com/s/files/1/0565/8021/0861/files/picked-up-completed.png?v=1731737530`;
const ReturnIntiated = `https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Refund-intiated.png?v=1731737477`;
const checkIcon = `https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Check_2.png?v=1729144944 `;
const cancelIcon =`https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Vector_1_39703a56-a40e-4561-bee3-721f9fa37f8c.png?v=1729927638`;
let ordername1;
let apiUrl;
let itemsToBeReordered;
let orderDetailsData;

const apiEndpointDetails = `https://supertails-backend.el.r.appspot.com/post-order/details/web?orderId=${orderId1}`;  

fetch(apiEndpointDetails, {
headers: {
'ngrok-skip-browser-warning': 'true'
}
})
.then(response => {
if (!response.ok) {
    throw new Error('Network response was not ok');
}
return response.json();
})
.then(data => {
orderDetailsData = data;
document.querySelector('.mrp').textContent = `₹${Math.round(orderDetailsData?.response?.totalMrp)}`;
document.querySelector('.discount').textContent = `-₹${Math.round(orderDetailsData?.response?.totalDiscountOnMrp)}`;
document.querySelector('.coupon-discount').textContent = `-₹${Math.round(parseFloat(orderDetailsData?.response?.discount))}`;
document.querySelector('.amt').textContent = `₹${Math.round(orderDetailsData?.response?.total)}`;
document.querySelector('.various_fees_render');
  const variousFeeDiv = document.querySelector('.various_fees_render');
  data.response.various_fees.forEach(item => {
     variousFeeDiv.innerHTML += `
        <div class="total-details">
           <div class="various_fee_div">
              <h5>${item.key}</h5>
           </div>
           <div>
              <p class="cod-fee">${item.value}</p>
           </div>
        </div>
  `;
  });
document.querySelector('.amt-payment-text').textContent = `${orderDetailsData?.response?.paymentMode}`; 
const orderDate = orderDetailsData?.response?.orderDate;
const dateObj = orderDate ? new Date(orderDate) : null;
let formattedDateNow = '';
if (dateObj && !isNaN(dateObj.getTime())) {
  const day = dateObj.getUTCDate();
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[dateObj.getUTCMonth()];
  const year = dateObj.getUTCFullYear();
  const hours = dateObj.getUTCHours();
  const minutes = dateObj.getUTCMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  const displayMinutes = minutes.toString().padStart(2, '0');
  const time = `${displayHours}:${displayMinutes} ${ampm}`;
  formattedDateNow = `${day} ${month}, ${year} . ${time}`;
}
document.querySelector('.item-time-text p').innerHTML = formattedDateNow;        
})
.catch(error => {
console.error('Error fetching order details:', error);
});

if (awb1 === null) {
if(returnRequestId !== null && returnRequestId !== ''){
apiUrl = `https://supertails-backend.el.r.appspot.com/post-order/shipment/web?orderId=${orderId1}&skus=${skus1}&return_request_id=${returnRequestId}`;
}else{
apiUrl = `https://supertails-backend.el.r.appspot.com/post-order/shipment/web?orderId=${orderId1}&skus=${skus1}`;
}
} else {
if(returnRequestId !== null && returnRequestId !== ''){
apiUrl = `https://supertails-backend.el.r.appspot.com/post-order/shipment/web?orderId=${orderId1}&awb=${awb1}&return_request_id=${returnRequestId}`;
}else{
apiUrl = `https://supertails-backend.el.r.appspot.com/post-order/shipment/web?orderId=${orderId1}&awb=${awb1}`;
}
}

fetch(apiUrl, {
headers: {
 'ngrok-skip-browser-warning': 'true'
}
})
.then(response => {
 if (!response.ok) {
 throw new Error('Network response was not ok');
}
 return response.json();
 })
.then(data => {
itemsToBeReordered = data.response.shipment.line_items;
fetch("https://supertails-backend.el.r.appspot.com/order/post-order/cancellation-reasons/web")
.then(response => {
 if (!response.ok) {
 throw new Error('Network response was not ok');
}
 return response.json();
 })
.then(cancelData => {
document.getElementById('cancel-order-id').textContent = `Order #${ordername1}`;
const answerContainer = document.querySelector('.a-container');
let activeButton = null;
let otherTextArea = null;
let otherHeader = null;
let otherDiv = null;

function toggleSubmitButtons(enable) {
 const yesCancelButton = document.querySelector('.yes-cancel');
 const dontCancelButton = document.querySelector('.dont-cancel');

 if (enable) {
   yesCancelButton.style.opacity = "unset";
   yesCancelButton.style.pointerEvents = "auto";
   dontCancelButton.style.opacity = "unset";
   dontCancelButton.style.pointerEvents = "auto";
 } else {
   yesCancelButton.style.opacity = "0.5";
   yesCancelButton.style.pointerEvents = "none";
   dontCancelButton.style.opacity = "0.5";
   dontCancelButton.style.pointerEvents = "none";
 }
}
    
cancelData.response.forEach(reason => {
 const reasonButton = document.createElement('button');
 reasonButton.classList.add('a-box');
reasonButton.innerHTML = `<p style=color: black">${reason.reason}</p>`;

 reasonButton?.addEventListener('click', function() {
   if (activeButton) {
     activeButton.classList.remove('clicked-style');
     activeButton.disabled = false;
     activeButton.removeAttribute('id');
   }
   if (otherDiv) {
     otherDiv.remove();
     otherDiv = null;
   }    
   reasonButton.classList.add('clicked-style');
   reasonButton.setAttribute('id', "active-button");
   document.querySelector('.otherbtn').style.display = "block";
   document.querySelector('.text-area-cancel').style.display = "block";
   reasonButton.disabled = true;   
   toggleSubmitButtons(true);     
   activeButton = reasonButton;
 });

 answerContainer?.appendChild(reasonButton);
});
   
const otherButton = document.createElement('button');
otherButton.classList.add('a-box');
otherButton.innerHTML = `<p>Others</p>`;

otherButton?.addEventListener('click', function() {

 if (activeButton) {
   activeButton.classList.remove('clicked-style');
   activeButton.disabled = false;
   activeButton.removeAttribute('id');
 }
  
 otherButton.classList.add('clicked-style');
 otherButton.setAttribute('id', "active-button");
 otherButton.disabled = true;
 
 toggleSubmitButtons(false);      
 if (!otherDiv) {         
   document.querySelector('.otherbtn').style.display = "none";   
   otherDiv = document.createElement('div');
   otherDiv.classList.add('textarea-container');    
   otherHeader = document.createElement('h1');
   otherHeader.textContent = "Why do you want to cancel?";
   otherTextArea = document.createElement('textarea');
   otherTextArea.setAttribute('placeholder', 'Please specify your reason');
   otherTextArea.classList.add('textarea-box');
   otherTextArea.classList.add('cancel_text_area');
   otherDiv?.appendChild(otherHeader);
   otherDiv?.appendChild(otherTextArea);
   const textAreaContainer = document.querySelector('.text-area-cancel');
   textAreaContainer?.appendChild(otherDiv);
   otherTextArea?.addEventListener('input', function() {
     if (otherTextArea.value.trim() !== '') {
       toggleSubmitButtons(true);
     } else {
       toggleSubmitButtons(false);
     }
   });
 }else{
  //otherDiv.style.display = "block";
  document.querySelector('.text-area-cancel').style.display = "block";

 }
 activeButton = otherButton;
});

answerContainer?.appendChild(otherButton);
const cancelitemsContainer = document.querySelector('.item-image-cont');

data.response.shipment.line_items.forEach(item => {

const itemImageDiv = document.createElement('div');
itemImageDiv.classList.add('item-image');

itemImageDiv.innerHTML = `
  <img src="${item.image_url}" loading="lazy">
`;

cancelitemsContainer?.appendChild(itemImageDiv);
document.getElementById('loader_123').style.display = "none";
document.getElementById('full-content-div').style.display = "block";
});

const header = document.querySelector('.cancel-next-header');
const body = document.querySelector('.cancel-next-body');
const footer = document.querySelector('.footer-cancel');
const continueBtn = document.querySelector('.continue-shop-button');

header?.addEventListener('animationend', () => {
body.style.visibility = 'visible';
footer.style.visibility = 'visible';
continueBtn.style.visibility = 'visible';

});
})

order_cof_id = data.response.orderId;
ordername1 = data.response.orderName;
const orderID = data.response.orderId;
const orderNo = document.getElementById('order-number');

orderNo.innerText = `Order #${ordername1}`;
const isOCDeliveryOrder = data.response?.shipment?.isQc;
const orderData = data.response.shipment;
sessionStorage.setItem("return-window-expiry-date", orderData?.returnWindowExpiryDate);
sessionStorage.setItem("order_line_items", JSON.stringify(orderData.line_items));
const awbEvent=orderData.awb;
dataLayer.push({
      event: "select_shipment",
      waybill : awbEvent
    });
    clevertap.event.push("select_shipment", {
     waybill : awbEvent
  });
  dataLayer.push({
      event: "view_shipment_details",
      waybill : awbEvent
    });
    clevertap.event.push("view_shipment_details", {
     waybill : awbEvent
  });
const pincode = data.response?.pincode;
document.getElementById('pincode').value = pincode;
localStorage.setItem('pincode', pincode);

const link = window.location.search;
const urlParamlink = new URLSearchParams(link);
const orderIdReturn = urlParamlink.get('orderId')
const returnRequestIdReturn = urlParamlink.get('returnRequestId')
const awbReturn = urlParamlink.get('awb')

if(orderData?.status.toLowerCase() == "return rejected"){
const selectedReturnItems = [];
orderData.line_items.forEach(item => {
  selectedReturnItems.push({
     item: item,
     quantity: item.quantity
  });
});
sessionStorage.setItem("return-window-expiry-date", orderData?.returnWindowExpiryDate);
localStorage.setItem("selected_items", JSON.stringify(selectedReturnItems));
document.getElementById('rescheduled-box-div').style.display = "block";
document.querySelector('.rescheduled-text').innertext = "";
document.querySelector('.rescheduled-text').innerHTML = "Return rejected due to the item not being in its original condition. <a href='https://supertails.com/pages/return-policy' target='_blank' style='color: #EF6C00; text-decoration: underline;'>Check return policy</a>";
document.querySelector('.rescheduled-btn').style.display = "none";
const reschedule_return_btn = document.createElement('a');
reschedule_return_btn.classList.add('reschedule-return-btn');
reschedule_return_btn.innerHTML = "Try again";
reschedule_return_btn.href = `https://supertails.com/pages/return-details?orderId=${orderIdReturn}&awb=${awbReturn}&returnRequestId=${returnRequestIdReturn}`;
document.getElementById('rescheduledBox').appendChild(reschedule_return_btn);
}

// if(orderData?.status.toLowerCase() == "delivery failed"){
// if(orderData?.failedDeliveryStatus.toLowerCase() == "pending"){
//   document.getElementById('rescheduled-box-div').style.display = "block";
// }
// else if(orderData?.failedDeliveryStatus.toLowerCase() == "rescheduled"){
//   document.getElementById('rescheduled-box-div').style.display = "block";
//   const svgdiv = document.querySelector('.rescheduled-icon');
//   svgdiv.innerHTML = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//            <path d="M7.00261 0.333496C5.68407 0.333496 4.39513 0.724489 3.29881 1.45703C2.20248 2.18957 1.34799 3.23077 0.84341 4.44894C0.338826 5.66711 0.206804 7.00756 0.464039 8.30077C0.721273 9.59397 1.35621 10.7819 2.28856 11.7142C3.22091 12.6466 4.4088 13.2815 5.70201 13.5387C6.99521 13.796 8.33566 13.6639 9.55383 13.1594C10.772 12.6548 11.8132 11.8003 12.5457 10.704C13.2783 9.60764 13.6693 8.31871 13.6693 7.00016C13.6693 6.12468 13.4968 5.25778 13.1618 4.44894C12.8268 3.6401 12.3357 2.90517 11.7167 2.28612C11.0976 1.66706 10.3627 1.176 9.55383 0.840966C8.74499 0.505935 7.87809 0.333496 7.00261 0.333496ZM10.7866 5.82483L6.78661 9.4915C6.65996 9.60762 6.49337 9.67037 6.32159 9.66664C6.14981 9.66291 5.9861 9.593 5.86461 9.4715L3.86461 7.4715C3.80093 7.41 3.75015 7.33644 3.71521 7.2551C3.68027 7.17376 3.66188 7.08628 3.66111 6.99776C3.66034 6.90924 3.67721 6.82146 3.71073 6.73953C3.74425 6.6576 3.79375 6.58316 3.85634 6.52057C3.91894 6.45797 3.99337 6.40847 4.0753 6.37495C4.15724 6.34143 4.24502 6.32456 4.33354 6.32533C4.42206 6.3261 4.50954 6.34449 4.59088 6.37943C4.67221 6.41437 4.74578 6.46516 4.80727 6.52883L6.35594 8.0775L9.88527 4.84216C10.0156 4.72264 10.188 4.65978 10.3647 4.6674C10.5414 4.67503 10.7077 4.75252 10.8273 4.88283C10.9468 5.01314 11.0097 5.18559 11.002 5.36225C10.9944 5.53891 10.9169 5.70531 10.7866 5.82483Z" fill="url(#paint0_linear_4412_3764)"></path>
//            <defs>
//               <linearGradient id="paint0_linear_4412_3764" x1="7.00261" y1="0.333496" x2="7.00261" y2="13.6668" gradientUnits="userSpaceOnUse">
//                  <stop stop-color="#01B23D"></stop>
//                  <stop offset="1" stop-color="#0B672B"></stop>
//               </linearGradient>
//            </defs>
//         </svg>`;
//   document.getElementById('reschedule-btn').style.display = "none";
//   document.querySelector('.rescheduled-text').textContent = "Your delivery has been rescheduled, and we will make another attempt to deliver it as planned.";
// }
// else if(orderData?.failedDeliveryStatus.toLowerCase() == "rto"){
//   document.getElementById('rescheduled-box-div').style.display = "block";
//   document.querySelector('.rescheduled-text').textContent = "We are trying to cancel your order. Otherwise, you can reject it at the time of delivery";
//   document.querySelector('.rescheduled-btn').style.display = "none";
// }
// }

if (orderData?.status.toLowerCase() == "pick up failed"){
document.getElementById('rescheduled-box-div').style.display = "block";
document.querySelector('.rescheduled-text').innerHTML = `<span>Your item could not be picked up today. We <b>will try again tomorrow</b></span> `;
document.querySelector('.rescheduled-btn').style.display = "none";
}

function getNextThreeDays() {  
const today = new Date();
const newDates = Array.from({ length: 3 }, (_, i) => {
const nextDate = new Date(today);
nextDate.setDate(today.getDate() + i + 1);
return `${nextDate.toLocaleString('en-US', { weekday: 'long' })}, 10 PM`;
});

return newDates;
}

function displayNextThreeDaysButtons(allPossibelReturndate) {
const dateOptionsContainer = document.getElementById("reschedule-date-options");

if (!dateOptionsContainer) {
console.error('Container element not found');
return;
}

const dates = getNextThreeDays();
dateOptionsContainer.innerHTML = "";

dates.forEach(date => {
const button = document.createElement("button");
button.className = "date-btn";
button.textContent = date;
button.setAttribute("data-date", date); // Add a data attribute for the date
dateOptionsContainer.appendChild(button);
});
}
const today = new Date();
displayNextThreeDaysButtons(today);
document.querySelector('.textdel').textContent = deliverytText;
document.querySelector('.delivery-order-number').textContent = ordername1;
document.querySelector('.track-info').textContent = deliverytText;
const stepOrderConfirmed = document.getElementById('step-order-confirmed');
const stepShipped = document.getElementById('step-shipped');
const stepOutForDelivery = document.getElementById('step-out-for-delivery');
const stepDelivered = document.getElementById('step-delivered');
const progressLine1 = document.getElementById('progress-line-1');
const progressLine2 = document.getElementById('progress-line-2');
const progressLine3 = document.getElementById('progress-line-3');
const placedIcon = document.getElementById('stepIcon');
const shippedIcon = document.getElementById('stepIcon2');
const outForDeliveryIcon = document.getElementById('stepIcon3');
const deliveredIcon = document.getElementById('stepIcon4');
const deliveryStatusCard = document.getElementById('delivery-status-card');
const deliveryStatus = document.getElementById('delivery-status');
const paymentContainerDiv = document.getElementById('payment-container');
const cancelSection = document.getElementById('cancel-container');
const returnDiv = document.querySelectorAll('#view-return-container');
const viewsummary = document.querySelectorAll('#view-summary-container');
const orderdeliveredtext = document.getElementById('order-delivered-text');
const activetext= document.getElementById('step-text-order');
const isOCDeliveryStatus = document.querySelector('.delivery-status-quick-delivery');

document.getElementById('viewDetailRedirection').addEventListener('click', viewDetailRedirection);

if (awb1 === null || awb1 === undefined) {
  const trackingHeader = document.querySelector(".tracking-header");
  if (trackingHeader) {
     trackingHeader.style.display = "none";
  }
}

function viewDetailRedirection(){
window.location.href = `https://supertails.com/pages/track-your-order/${order_cof_id}`;
}

function resetStepTextStyles() {
const allStepTexts = document.querySelectorAll('.step-text');
allStepTexts.forEach(stepText => {
  stepText.classList.remove('active-text');
});
}

function formatToCustomDate(isoString) {
  if (!isoString || isoString === '' || isoString === null || isoString === undefined) {
    return '';
  }
  
  const date = new Date(isoString);
  
  // Check if date is valid
  if (isNaN(date.getTime())) {
    return '';
  }

  const day = date.getUTCDate();
  const month = date.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' });
  const ordinalSuffix = (day) => {
    if (day > 3 && day < 21) return 'th'; // Covers 11th - 19th
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  return `On ${day}${ordinalSuffix(day)}, ${month}`;
}

const deliveryInfoHeader = document.querySelector('.delivery-info-header');

switch(orderData?.status.toLowerCase())
{
case "order placed":
resetStepTextStyles();
stepOrderConfirmed.classList.add('active');
placedIcon?.appendChild(createImageIcon(placedorder));  
deliveryStatusCard.style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.style.display = 'none');
activetext.classList.add('active-text');
orderdeliveredtext.style.display = 'none';
const lineBetween = document.querySelector('.progress-line-between1');
lineBetween.classList.add('inner-line');
lineBetween.style.width = '20%';
document.querySelector('.post_cancel_refund_div').style.display = "none"; 

break;

case "items packed":
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.style.display = 'none');
document.querySelector('.post_cancel_refund_div').style.display = 'none';
document.querySelector('.delivery-status-quick-delivery').style.display = 'block';
document.querySelector('.delivery-status').style.display = 'none';
document.querySelector('.order-delivered-text').style.display = 'none';
if(window.innerWidth <= 575){
const innerContainer = document.querySelector('.inner-cont');
innerContainer.style.width = '100%';
innerContainer.style.margin = '0';
const shipppedMweb = document.querySelector('.shippped-mweb');
shipppedMweb.style.height = '238px';
const imgFluid = document.querySelector('#img-cont-mweb');
imgFluid.style.height = '156px';
document.querySelector('.circle-cont').style.marginLeft = '26px';
const circleMweb = document.querySelector('.circle-mweb');
circleMweb.style.padding = '11px';
circleMweb.style.width = '128px';
circleMweb.style.height = '128px';
}

break;

case "packing items":
document.querySelector('.post_cancel_refund_div').style.display = 'none';
document.querySelector('.delivery-status-quick-delivery').style.display = 'block';
document.querySelector('.delivery-status').style.display = 'none';
document.querySelector('.order-delivered-text').style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.style.display = 'none');
if(window.innerWidth <= 575){
const innerContainer = document.querySelector('.inner-cont');
innerContainer.style.width = '100%';
innerContainer.style.margin = '0';
const shipppedMweb = document.querySelector('.shippped-mweb');
shipppedMweb.style.height = '238px';
const imgFluid = document.querySelector('#img-cont-mweb');
imgFluid.style.height = '156px';
document.querySelector('.circle-cont').style.marginLeft = '26px';
const circleMweb = document.querySelector('.circle-mweb');
circleMweb.style.padding = '11px';
circleMweb.style.width = '128px';
circleMweb.style.height = '128px';
}

break;

case "picking your items":
document.querySelector('.post_cancel_refund_div').style.display = 'none';
document.querySelector('.delivery-status-quick-delivery').style.display = 'block';
document.querySelector('.delivery-status').style.display = 'none';
document.querySelector('.order-delivered-text').style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.style.display = 'none');
if(window.innerWidth <= 575){
const innerContainer = document.querySelector('.inner-cont');
innerContainer.style.width = '100%';
innerContainer.style.margin = '0';
const shipppedMweb = document.querySelector('.shippped-mweb');
shipppedMweb.style.height = '238px';
const imgFluid = document.querySelector('#img-cont-mweb');
imgFluid.style.height = '156px';
document.querySelector('.circle-cont').style.marginLeft = '26px';
const circleMweb = document.querySelector('.circle-mweb');
circleMweb.style.padding = '11px';
circleMweb.style.width = '128px';
circleMweb.style.height = '128px';
}

break;

case "order picked up":
document.querySelector('.post_cancel_refund_div').style.display = 'none';
document.querySelector('.delivery-status-quick-delivery').style.display = 'block';
document.querySelector('.delivery-status').style.display = 'none';
document.querySelector('.order-delivered-text').style.display = 'none';
if(window.innerWidth <= 575){
const innerContainer = document.querySelector('.inner-cont');
innerContainer.style.width = '100%';
innerContainer.style.margin = '0';
const shipppedMweb = document.querySelector('.shippped-mweb');
shipppedMweb.style.height = '238px';
const imgFluid = document.querySelector('#img-cont-mweb');
imgFluid.style.height = '156px';
document.querySelector('.circle-cont').style.marginLeft = '26px';
const circleMweb = document.querySelector('.circle-mweb');
circleMweb.style.padding = '11px';
circleMweb.style.width = '128px';
circleMweb.style.height = '128px';
}

break;


case "reached your location":
document.querySelector('.post_cancel_refund_div').style.display = 'none';
document.querySelector('.delivery-status-quick-delivery').style.display = 'block';
document.querySelector('.delivery-status').style.display = 'none';
document.querySelector('.order-delivered-text').style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.style.display = 'none');
if(window.innerWidth <= 575){
const innerContainer = document.querySelector('.inner-cont');
innerContainer.style.width = '100%';
innerContainer.style.margin = '0';
const shipppedMweb = document.querySelector('.shippped-mweb');
shipppedMweb.style.height = '238px';
const imgFluid = document.querySelector('#img-cont-mweb');
imgFluid.style.height = '156px';
document.querySelector('.circle-cont').style.marginLeft = '26px';
const circleMweb = document.querySelector('.circle-mweb');
circleMweb.style.padding = '11px';
circleMweb.style.width = '128px';
circleMweb.style.height = '128px';
}

break;

case "reached nearest hub":
resetStepTextStyles(); 
stepOrderConfirmed.classList.add('completed');
placedIcon?.appendChild(createImageIcon(checkIcon)); 
shippedIcon?.appendChild(createImageIcon(shippedorder));
stepShipped.classList.add('active');
progressLine1.classList.add('completed');
deliveryStatusCard.style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.style.display = 'none');
document.getElementById('step-text-shipped').classList.add('active-text');
orderdeliveredtext.style.display = 'none';
document.querySelector('.progress-line-between2').classList.add('inner-line');
document.querySelector('.progress-line-between2').style.width = '75%';
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
break;

case "order shipped":
resetStepTextStyles(); 
stepOrderConfirmed.classList.add('completed');
placedIcon?.appendChild(createImageIcon(checkIcon)); 
shippedIcon?.appendChild(createImageIcon(shippedorder));
stepShipped.classList.add('active');
progressLine1.classList.add('completed');
deliveryStatusCard.style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.style.display = 'none');
document.getElementById('step-text-shipped').classList.add('active-text');
orderdeliveredtext.style.display = 'none';
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
if (isOCDeliveryOrder){
  document.querySelector('.delivery-status').style.display = 'none';
  document.querySelector('.delivery-status-quick-delivery').style.display = 'block';
  if(window.innerWidth <= 575){
    document.querySelector('.inner-cont').classList.add('inner-cont-out-for-delivery-mweb');
    document.querySelector('.shippped-mweb').style.height = '238px';
    document.querySelector('#img-cont-mweb').style.height = '156px';
    document.querySelector('.circle-cont').style.marginLeft = '5px';
    const circleMweb = document.querySelector('.circle-mweb');
    circleMweb.style.padding = '11px';
    circleMweb.style.width = '128px';
    circleMweb.style.height = '128px';
  }
}
break;


case "out for delivery":
resetStepTextStyles(); 
placedIcon?.appendChild(createImageIcon(checkIcon)); 
shippedIcon?.appendChild(createImageIcon(checkIcon));
outForDeliveryIcon?.appendChild(createImageIcon(ofd));
stepOrderConfirmed.classList.add('completed');
stepShipped.classList.add('completed');
stepOutForDelivery.classList.add('active');
progressLine1.classList.add('completed');
progressLine2.classList.add('completed');
deliveryStatusCard.style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.style.display = 'none');
document.getElementById('step-text-ofd').classList.add('active-text'); 
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
orderdeliveredtext.style.display = 'none';
if (isOCDeliveryOrder){
document.querySelector('.delivery-status').style.display = 'none';
document.querySelector('.delivery-status-quick-delivery').style.display = 'block';
if(window.innerWidth <= 575){
  document.querySelector('.inner-cont').classList.add('inner-cont-out-for-delivery-mweb');
  document.querySelector('.shippped-mweb').style.height = '238px';
  document.querySelector('#img-cont-mweb').style.height = '156px';
  document.querySelector('.circle-cont').style.marginLeft = '5px';
  const circleMweb = document.querySelector('.circle-mweb');
  circleMweb.style.padding = '11px';
  circleMweb.style.width = '128px';
  circleMweb.style.height = '128px';
}
}
break;

case "delivery failed":
placedIcon?.appendChild(createImageIcon(checkIcon));
shippedIcon?.appendChild(createImageIcon(checkIcon));
outForDeliveryIcon?.appendChild(createImageIcon(checkIcon));
stepOrderConfirmed.classList.add('completed');
stepShipped.classList.add('completed');
stepOutForDelivery.classList.add('completed');
stepDelivered.classList.add('completed');
progressLine1.classList.add('completed');
progressLine2.classList.add('completed');
progressLine3.classList.add('failed');
deliveredIcon?.appendChild(createImageIcon(cancelIcon));
deliveredIcon.classList.add('failed-icon');
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.style.display = 'none');
document.getElementById('step-text-failed').classList.add('active-text');
orderdeliveredtext.style.display = 'none';
deliveryStatusCard.style.display = 'none';
document.querySelector('.circle-cont').style.display = 'none';
document.querySelector('#step-text-failed span').textContent = 'Not Delivered';
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
if (isOCDeliveryOrder){
document.querySelector('.delivery-status').style.display = 'none';
document.querySelector('.delivery-status-quick-delivery').style.display = 'block';
document.querySelector('.quick-delivery-status-update-icon').innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.5449 17.954C19.7563 18.1653 19.875 18.452 19.875 18.7509C19.875 19.0497 19.7563 19.3364 19.5449 19.5477C19.3336 19.7591 19.0469 19.8778 18.748 19.8778C18.4492 19.8778 18.1625 19.7591 17.9512 19.5477L11.999 13.5937L6.04492 19.5459C5.83358 19.7572 5.54693 19.8759 5.24805 19.8759C4.94916 19.8759 4.66251 19.7572 4.45117 19.5459C4.23983 19.3345 4.12109 19.0479 4.12109 18.749C4.12109 18.4501 4.23983 18.1635 4.45117 17.9521L10.4052 11.9999L4.45305 6.04586C4.2417 5.83451 4.12297 5.54787 4.12297 5.24898C4.12297 4.9501 4.2417 4.66345 4.45305 4.45211C4.66439 4.24076 4.95103 4.12203 5.24992 4.12203C5.54881 4.12203 5.83545 4.24076 6.0468 4.45211L11.999 10.4062L17.953 4.45117C18.1644 4.23983 18.451 4.12109 18.7499 4.12109C19.0488 4.12109 19.3354 4.23983 19.5468 4.45117C19.7581 4.66251 19.8769 4.94916 19.8769 5.24804C19.8769 5.54693 19.7581 5.83358 19.5468 6.04492L13.5927 11.9999L19.5449 17.954Z" fill="#D71212"/>
</svg>
`;
document.querySelector('#img-cont-mweb').style.height = '136px';
}
break;

case "delivered":
deliveryStatusCard.style.display = 'block';
paymentContainerDiv.classList.add('delivery-complete');
deliveryStatus.classList.add('delivery-complete');
cancelSection.classList.add('delivery-complete');
returnDiv.forEach(element => element.classList.add('return-active'));
viewsummary.forEach(element => element.classList.add('return-unactive'));
document.querySelector('.circle-cont').style.display = 'none';
document.querySelectorAll('#view-summary-small').forEach(element => element.style.display = 'none');
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
document.getElementById('delivery-card').classList.add('show-delivery-card');

if (window.innerWidth <= 575) {
const orderDeliveredText = document.querySelector('.order-delivered-text');
orderDeliveredText.classList.add('delivered-order-new');
document.getElementById('img-cont-mweb').style.height = '138px';
document.querySelector('.shippped-mweb').style.height = '240px';
document.querySelector('.order-status-location').style.marginLeft = '16px';
}

let totalQuantity = 0;
orderData.line_items.forEach(item => {
  totalQuantity += item.quantity;
});

let returnedQuantity = orderData.returnedQuantity ?? 0;

if (orderData.isReturnable && returnedQuantity !== totalQuantity) {
document.getElementById('return-items').style.display = "flex";
}
else{
document.getElementById('return-items').style.display = "none";
}

break;

case "cancelled":
document.getElementById('delivery-status-card').style.display = "none";
document.getElementById('delivery-status').style.display = "none";
paymentContainerDiv.style.display = 'none';
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_div').style.display = "block"; 
document.querySelector('.shippped-mweb').style.display = "none";
document.getElementById('order-delivered-text').style.display = "none";
document.querySelectorAll('#view-summary-container').forEach(element => element.style.display = 'none');
document.querySelectorAll('#view-summary-small').forEach(element => element.style.display = 'none');
document.querySelectorAll('#return-items').forEach(element => element.style.display = 'none');
document.querySelectorAll('.return-divider').forEach(element => element.style.display = 'none');
document.getElementById('return-items').style.display = 'none';
document.getElementById('view-summary-container').style.display = 'none'; 
document.querySelector('.post_cancel_refund_div').style.display = "none"; 

if(data?.response?.displayFinancialStatus =='REFUNDED'){
document.querySelector('.post_cancel_div').style.display = "none"; 
document.querySelector('.post_cancel_refund_div').style.display = "block"; 
}

break;

case "refunded":
document.getElementById('delivery-status-card').style.display = "none";
document.getElementById('delivery-status').style.display = "none";
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_div').style.display = "none"; 
document.querySelector('.shippped-mweb').style.display = "none";
document.getElementById('order-delivered-text').style.display = "none";
document.getElementById('view-return-container').style.display = "none"; 
document.querySelector('.post_cancel_refund_div').style.display = "block"; 
document.getElementById('payment-container').style.display="flex";
document.getElementById('order-box').style.display="none";
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.classList.add('return-unactive'));

const isFullyRefunded = orderData.line_items.every(
  (item) => item?.quantity === item?.returnedQuantity,
);

if (isFullyRefunded) {
document.querySelector('.post_cancel_text h1').textContent = "Your order has been refunded";
document.querySelector('.post_cancel_text p').textContent = "Your item has been collected, and the refund has been processed successfully. We hope to serve you again soon!";
}
else {
document.querySelector('.post_cancel_text h1').textContent = "Partial refund processed";
document.querySelector('.post_cancel_text p').textContent = "The returned item has been picked up, and your refund is complete. We hope to serve you again soon!";
}

break;

case "return requested":
deliveryInfoHeader.innerHTML = "<img src='https://cdn.shopify.com/s/files/1/0565/8021/0861/files/return-request.png?v=1731737413' alt='truck-icon' style='width: 21px; height: 22px; margin-left: 10px;'>";
resetStepTextStyles();
stepOrderConfirmed.classList.add('active');
placedIcon?.appendChild(createImageIcon(ReturnRequest)); 
document.querySelector('#step-text-order span').textContent = 'Return Requested';
document.querySelector('#step-text-shipped span').textContent = 'Request approved';
document.querySelector('#step-text-ofd span').textContent = 'Pick up completed';
document.querySelector('#step-text-failed span').textContent = 'Refunded';
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
deliveryStatusCard.style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.classList.add('return-unactive'));
activetext.classList.add('active-text');
orderdeliveredtext.style.display = 'none';
document.querySelector('.address-div').style.display = 'none';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.getElementById('payment-container').style.display = 'none';
document.getElementById('time-status-mweb').style.display = 'none';
document.getElementById('cancel-container').style.display = "none";
document.querySelector('#step-date-order1').textContent = (orderData?.trackingData?.[0]?.date) ? formatToCustomDate(orderData.trackingData[0].date) : '';
document.querySelector('#step-date-order2').textContent = (orderData?.trackingData?.[1]?.expectedDate) ? formatToCustomDate(orderData.trackingData[1].expectedDate) : '';
document.querySelector('#step-date-order3').textContent = (orderData?.trackingData?.[2]?.expectedDate) ? formatToCustomDate(orderData.trackingData[2].expectedDate) : '';
document.querySelector('#step-date-order4').textContent = (orderData?.trackingData?.[3]?.expectedDate) ? formatToCustomDate(orderData.trackingData[3].expectedDate) : '';

break;

case "pick up failed":
deliveryInfoHeader.innerHTML = "<img src='https://cdn.shopify.com/s/files/1/0565/8021/0861/files/X_5a3bcbfa-9b93-479e-8e72-dcf8b4a85667.png?v=1747041495' alt='truck-icon' style='width: 21px; height: 22px; margin-left: 10px;'>"; 
resetStepTextStyles(); 
placedIcon?.appendChild(createImageIcon(checkIcon)); 
shippedIcon?.appendChild(createImageIcon(checkIcon));
outForDeliveryIcon?.appendChild(createImageIcon(cancelIcon));
outForDeliveryIcon.classList.add('failed-icon');
stepOrderConfirmed.classList.add('completed');
stepShipped.classList.add('completed');
stepOutForDelivery.classList.add('failed');;
progressLine1.classList.add('completed');
progressLine2.classList.add('failed');
deliveryStatusCard.style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.classList.add('return-unactive'));
document.getElementById('step-text-ofd').classList.add('active-text'); 
orderdeliveredtext.style.display = 'none';
document.querySelector('.address-div').style.display = 'block';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.querySelector('#step-text-order span').textContent = 'Return Requested';
document.querySelector('#step-text-shipped span').textContent = 'Request approved';
document.querySelector('#step-text-ofd span').textContent = 'Item not picked up';
document.querySelector('#step-text-failed span').textContent = 'Refunded';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.getElementById('payment-container').style.display = 'none';
document.getElementById('time-status-mweb').style.display = 'none';
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
document.querySelector('.circle-cont').style.display = 'none';
document.querySelector('#step-date-order1').textContent = (orderData?.trackingData?.[0]?.date) ? formatToCustomDate(orderData.trackingData[0].date) : '';
document.querySelector('#step-date-order2').textContent = (orderData?.trackingData?.[1]?.date) ? formatToCustomDate(orderData.trackingData[1].date) : '';
document.querySelector('#step-date-order3').textContent = (orderData?.trackingData?.[4]?.date) ? formatToCustomDate(orderData.trackingData[4].date) : '';
document.querySelector('#step-date-order4').textContent = (orderData?.trackingData?.[3]?.expectedDate) ? formatToCustomDate(orderData.trackingData[3].expectedDate) : '';

break;

case "return out for pickup":
deliveryInfoHeader.innerHTML = "<img src='https://cdn.shopify.com/s/files/1/0565/8021/0861/files/picked-up-completed.png?v=1731737530' alt='truck-icon' style='width: 21px; height: 22px; margin-left: 10px;'>"; 
resetStepTextStyles(); 
placedIcon?.appendChild(createImageIcon(checkIcon)); 
shippedIcon?.appendChild(createImageIcon(checkIcon));
outForDeliveryIcon?.appendChild(createImageIcon(ReturnPickedup));
stepOrderConfirmed.classList.add('completed');
stepShipped.classList.add('completed');
stepOutForDelivery.classList.add('active');
progressLine1.classList.add('completed');
progressLine2.classList.add('completed');
deliveryStatusCard.style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.classList.add('return-unactive'));
document.getElementById('step-text-ofd').classList.add('active-text'); 
orderdeliveredtext.style.display = 'none';
document.querySelector('.address-div').style.display = 'block';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.querySelector('#step-text-order span').textContent = 'Return Requested';
document.querySelector('#step-text-shipped span').textContent = 'Request approved';
document.querySelector('#step-text-ofd span').textContent = 'Out for pickup';
document.querySelector('#step-text-failed span').textContent = 'Refunded';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.getElementById('payment-container').style.display = 'none';
document.getElementById('time-status-mweb').style.display = 'none';
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
document.querySelector('.circle-cont').style.display = 'none';
document.querySelector('#step-date-order1').textContent = (orderData?.trackingData?.[0]?.date) ? formatToCustomDate(orderData.trackingData[0].date) : '';
document.querySelector('#step-date-order2').textContent = (orderData?.trackingData?.[1]?.date) ? formatToCustomDate(orderData.trackingData[1].date) : '';
document.querySelector('#step-date-order3').textContent = (orderData?.trackingData?.[2]?.date) ? formatToCustomDate(orderData.trackingData[2].date) : '';
document.querySelector('#step-date-order4').textContent = (orderData?.trackingData?.[3]?.expectedDate) ? formatToCustomDate(orderData.trackingData[3].expectedDate) : '';

break;

case "return approved":
deliveryInfoHeader.innerHTML = "<img src='https://cdn.shopify.com/s/files/1/0565/8021/0861/files/request-approved.png?v=1731737438' alt='truck-icon' style='width: 21px; height: 22px; margin-left: 10px;'>";
resetStepTextStyles(); 
stepOrderConfirmed.classList.add('completed');
placedIcon?.appendChild(createImageIcon(checkIcon)); 
shippedIcon?.appendChild(createImageIcon(ReturnApproved));
stepShipped.classList.add('active');
progressLine1.classList.add('completed');
deliveryStatusCard.style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.classList.add('return-unactive'));
document.getElementById('view-summary-container').style.display = 'block';
document.getElementById('step-text-shipped').classList.add('active-text');
//document.querySelectorAll('#return-items').forEach(element => element.style.display = 'none');
orderdeliveredtext.style.display = 'none';
document.querySelector('#step-text-order span').textContent = 'Return Requested';
document.querySelector('#step-text-shipped span').textContent = 'Request approved';
document.querySelector('#step-text-ofd span').textContent = 'Pick up completed';
document.querySelector('#step-text-failed span').textContent = 'Refunded';
document.querySelector('.address-div').style.display = 'block';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.getElementById('payment-container').style.display = 'none';
document.getElementById('time-status-mweb').style.display = 'none';
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
document.getElementById('view-return-container').style.display="none";
document.querySelector('#step-date-order1').textContent = (orderData?.trackingData?.[0]?.date) ? formatToCustomDate(orderData.trackingData[0].date) : '';
document.querySelector('#step-date-order2').textContent = (orderData?.trackingData?.[1]?.date) ? formatToCustomDate(orderData.trackingData[1].date) : '';
document.querySelector('#step-date-order3').textContent = (orderData?.trackingData?.[2]?.expectedDate) ? formatToCustomDate(orderData.trackingData[2].expectedDate) : '';
document.querySelector('#step-date-order4').textContent = (orderData?.trackingData?.[3]?.expectedDate) ? formatToCustomDate(orderData.trackingData[3].expectedDate) : '';

break;

case "return item picked up":
deliveryInfoHeader.innerHTML = "<img src='https://cdn.shopify.com/s/files/1/0565/8021/0861/files/picked-up-completed.png?v=1731737530' alt='truck-icon' style='width: 21px; height: 22px; margin-left: 10px;'>"; 
resetStepTextStyles(); 
placedIcon?.appendChild(createImageIcon(checkIcon)); 
shippedIcon?.appendChild(createImageIcon(checkIcon));
outForDeliveryIcon?.appendChild(createImageIcon(ReturnPickedup));
stepOrderConfirmed.classList.add('completed');
stepShipped.classList.add('completed');
stepOutForDelivery.classList.add('active');
progressLine1.classList.add('completed');
progressLine2.classList.add('completed');
deliveryStatusCard.style.display = 'none';
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.classList.add('return-unactive'));
document.getElementById('step-text-ofd').classList.add('active-text'); 
orderdeliveredtext.style.display = 'none';
document.querySelector('.address-div').style.display = 'none';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.querySelector('#step-text-order span').textContent = 'Return Requested';
document.querySelector('#step-text-shipped span').textContent = 'Request approved';
document.querySelector('#step-text-ofd span').textContent = 'Pick up completed';
document.querySelector('#step-text-failed span').textContent = 'Refunded';
document.querySelector('.address-div').style.display = 'block';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.getElementById('payment-container').style.display = 'none';
document.getElementById('time-status-mweb').style.display = 'none';
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
document.querySelector('#step-date-order1').textContent = (orderData?.trackingData?.[0]?.date) ? formatToCustomDate(orderData.trackingData[0].date) : '';
document.querySelector('#step-date-order2').textContent = (orderData?.trackingData?.[1]?.date) ? formatToCustomDate(orderData.trackingData[1].date) : '';
document.querySelector('#step-date-order3').textContent = (orderData?.trackingData?.[2]?.date) ? formatToCustomDate(orderData.trackingData[2].date) : '';
document.querySelector('#step-date-order4').textContent = (orderData?.trackingData?.[3]?.expectedDate) ? formatToCustomDate(orderData.trackingData[3].expectedDate) : '';

break;

case "out for pickup":
resetStepTextStyles(); 
placedIcon?.appendChild(createImageIcon(checkIcon)); 
shippedIcon?.appendChild(createImageIcon(checkIcon));
outForDeliveryIcon?.appendChild(createImageIcon(ReturnPickedup));
stepOrderConfirmed.classList.add('completed');
stepShipped.classList.add('completed');
stepOutForDelivery.classList.add('active');
progressLine1.classList.add('completed');
progressLine2.classList.add('completed');
deliveryStatusCard.style.display = 'none';
returnDiv.classList.add('return-unactive');
document.getElementById('step-text-ofd').classList.add('active-text'); 
orderdeliveredtext.style.display = 'none';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.querySelector('#step-text-order span').textContent = 'Return Requested';
document.querySelector('#step-text-shipped span').textContent = 'Request approved';
document.querySelector('#step-text-ofd span').textContent = 'Out for pickup';
document.querySelector('#step-text-failed span').textContent = 'Refunded';
document.querySelector('.address-div').style.display = 'block';
document.querySelector('#step-date-order1').textContent = (orderData?.trackingData?.[0]?.date) ? formatToCustomDate(orderData.trackingData[0].date) : '';
document.querySelector('#step-date-order2').textContent = (orderData?.trackingData?.[1]?.date) ? formatToCustomDate(orderData.trackingData[1].date) : '';
document.querySelector('#step-date-order3').textContent = (orderData?.trackingData?.[2]?.date) ? formatToCustomDate(orderData.trackingData[2].date) : '';
document.querySelector('#step-date-order4').textContent = (orderData?.trackingData?.[3]?.expectedDate) ? formatToCustomDate(orderData.trackingData[3].expectedDate) : '';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.getElementById('payment-container').style.display = 'none';
document.getElementById('time-status-mweb').style.display = 'none';
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
document.querySelector('.circle-cont').style.display = 'none';

break;

case "return rejected": 
resetStepTextStyles(); 
deliveryInfoHeader.innerHTML = "<img src='https://cdn.shopify.com/s/files/1/0565/8021/0861/files/X_5a3bcbfa-9b93-479e-8e72-dcf8b4a85667.png?v=1747041495' alt='truck-icon' style='width: 21px; height: 22px; margin-left: 10px;'>"; 
deliveryInfoHeader.style.width = '28px';
placedIcon?.appendChild(createImageIcon(checkIcon)); 
shippedIcon?.appendChild(createImageIcon(cancelIcon));
shippedIcon.classList.add('failed-icon');
stepOrderConfirmed.classList.add('completed');
stepShipped.classList.add('failed');
progressLine1.classList.add('failed');
deliveryStatusCard.style.display = 'none';
viewsummary.forEach(element => element.classList.add('return-unactive'));
returnDiv.forEach(element => element.classList.add('return-unactive'));
document.querySelectorAll('#view-summary-small').forEach(element => element.style.display = 'none');
document.querySelectorAll('#return-items').forEach(element => element.style.display = 'none');
document.querySelectorAll('.return-divider').forEach(element => element.style.display = 'none');
document.getElementById('step-text-shipped').classList.add('active-text'); 
orderdeliveredtext.style.display = 'none';
document.querySelector('.address-div').style.display = 'block';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.querySelector('#step-text-order span').textContent = 'Return Requested';
document.querySelector('#step-text-shipped span').textContent = 'Request Rejected';
document.querySelector('#step-text-ofd span').textContent = 'Pick up completed';
document.querySelector('#step-text-failed span').textContent = 'Refunded';
document.querySelector('.view-tracking-updates').style.display = 'none';
document.getElementById('payment-container').style.display = 'none';
document.getElementById('time-status-mweb').style.display = 'none';
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_refund_div').style.display = "none"; 
document.querySelector('.circle-cont').style.display = 'none';
document.querySelector('#step-date-order1').textContent = (orderData?.trackingData?.[0]?.date) ? formatToCustomDate(orderData.trackingData[0].date) : '';
document.querySelector('#step-date-order2').textContent = (orderData?.trackingData?.[1]?.date) ? formatToCustomDate(orderData.trackingData[1].date) : '';
document.querySelector('#step-date-order3').textContent = (orderData?.trackingData?.[2]?.expectedDate) ? formatToCustomDate(orderData.trackingData[2].expectedDate) : '';
document.querySelector('#step-date-order4').textContent = (orderData?.trackingData?.[3]?.expectedDate) ? formatToCustomDate(orderData.trackingData[3].expectedDate) : '';
break;

case "returned to supertails":
placedIcon?.appendChild(createImageIcon(checkIcon));
shippedIcon?.appendChild(createImageIcon(checkIcon));
outForDeliveryIcon?.appendChild(createImageIcon(checkIcon));
stepOrderConfirmed.classList.add('completed');
stepShipped.classList.add('completed');
stepOutForDelivery.classList.add('completed');
stepDelivered.classList.add('completed');
progressLine1.classList.add('completed');
progressLine2.classList.add('completed');
progressLine3.classList.add('failed');
deliveredIcon?.appendChild(createImageIcon('https://cdn.shopify.com/s/files/1/0565/8021/0861/files/returned_to_origin.png?v=1734347219'));
deliveredIcon.classList.add('failed-icon');
returnDiv.forEach(element => element.classList.add('return-unactive'));
viewsummary.forEach(element => element.classList.add('return-unactive'));
document.getElementById('step-text-failed').classList.add('active-text');
orderdeliveredtext.style.display = 'none';
deliveryStatusCard.style.display = 'none';
document.querySelector('#step-text-failed span').textContent = 'Returned to Supertails';
document.getElementById('payment-container').style.display = 'none';
document.getElementById('time-status-mweb').style.display = 'none';
document.getElementById('cancel-container').style.display = "none";
document.querySelector('.post_cancel_refund_div').style.display = "none"; 

break;

default:
break;
}

const imageMap = {
'order placed': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Confirmed_mweb.png?v=1729015428',
'order shipped': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_In_transit.png?v=1729678838',
'out for delivery':'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_OFD.png?v=1729678851',
'delivered': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_Early_delivery.png?v=1729678823',
'delivery failed': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_OFD.png?v=1729678851',
'return requested': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_Early_delivery.png?v=1729678823',
'pick up failed': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_Early_delivery.png?v=1729678823',
'return out for pickup': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_Early_delivery.png?v=1729678823',
'return approved': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_Early_delivery.png?v=1729678823',
'return item picked up': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_Early_delivery.png?v=1729678823',
'returned to supertails': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_Early_delivery.png?v=1729678823',
'return rejected': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_OFD.png?v=1729678851',
'reached nearest hub':'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Property_1_OFD.png?v=1729678851',
'items packed': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Group_1410082988_29319c63-03fe-4ee5-8b21-61b07fc36f8c.png?v=1764669659',
'picking your items': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Group_1410082987.png?v=1764671338',
'reached your location': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Group_1410083024.png?v=1764529042',
'packing items': 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Group_1410082988_29319c63-03fe-4ee5-8b21-61b07fc36f8c.png?v=1764669659',
};

const imageGap = {
'order placed': 105,
'order shipped': 33,
'out for delivery': 35,
'delivered': 30,
'return requested': 30,
'return approved': 30,
'return item picked up': 30,
'returned to supertails': 30,
'reached nearest hub': 35,
'out for pickup': 30,
'items packed': 33,
'picking your items': 33,
'packing items': 33,
'reached your location': 35,
};


if (orderData.status.toLowerCase() && imageMap[orderData.status.toLowerCase()]) {
const imgElement = document.getElementById('img-cont-mweb');
imgElement.src = imageMap[orderData.status.toLowerCase()];
if (isOCDeliveryOrder && orderData.status.toLowerCase() == 'delivery failed'){
  imgElement.src = 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/PACKING_01_1_1.png?v=1764703589';
}
const imgContainer = document.getElementById('inner-cont-mweb');
imgContainer.style.gap=`${imageGap[orderData.status.toLowerCase()]}px`;
if (isOCDeliveryOrder && orderData.status.toLowerCase() == 'out for delivery'){
  imgElement.src = 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Group_1410082993.png?v=1764705291';
  imgContainer.style.gap=`${30}px`;
}

if (isOCDeliveryOrder && orderData.status.toLowerCase() == 'order shipped'){
  imgElement.src = 'https://cdn.shopify.com/s/files/1/0565/8021/0861/files/Group_1410082993.png?v=1764705291';
  imgContainer.style.gap=`${30}px`;
}
}

if(orderData?.deliveryPartner?.contactNumber){
if (isOCDeliveryOrder){
document.querySelector('.call-icon-button').style.display = "flex";
document.querySelector('.call-icon-button')?.addEventListener('click', function() {
  if (orderData?.deliveryPartner?.contactNumber) {
     window.location.href = `tel:${orderData.deliveryPartner.contactNumber}`;
  }
});
}
else{
document.querySelector('.call-icon-button').style.display = "none";
}

}

document.getElementById('callIcon')?.addEventListener('click', function() {
if (orderData?.deliveryPartner?.contactNumber) {
window.location.href = `tel:${orderData.deliveryPartner.contactNumber}`;
} else {
document.getElementById('deliveryPartnerBox').style.display = 'none';
}
});



const deliveryAdd = data.response?.deliveryAddress;
const deliveryAddWeb= document.getElementById('address-text');
const deliveryAddress = document.getElementById('delivered-address');
deliveryAddress.innerText = deliveryAdd;
const deliveryAddressDiv = document.getElementById('deliveryAddress');
deliveryAddressDiv.innerHTML += ` ${deliveryAdd}`;
deliveryAddWeb.innerText += deliveryAdd; 

const deliveryAddressQuickDelivery = document.querySelector('.quick-delivery-address-div p');
deliveryAddressQuickDelivery.innerText = deliveryAdd;

document.querySelector('.quick-delivery-status-update p').innerText = orderData?.deliveryPartner?.mainStatus || '';
document.querySelector('.delivery-boy-tracker p').innerText = orderData?.deliveryPartner?.supplementaryStatus || '';

const delaystatustext = orderData.message;
const deliverytext = document.getElementById('status-text')

let itemImage=orderData.line_items;    
const delaystatustime = orderData?.delayStatus ?? '';
const delaystatusDiv = document.getElementById('delaystatus-text');
const deliveredTextDiv = document.getElementById('delivered-text');
const arrivingtextmweb = document.getElementById('arriving-text-mweb');
const timestatusMweb = document.getElementById('time-status-mweb');

const delaystatusTextQuickDelivery = document.getElementById('delaystatus-text-quick-delivery');

let returnRequestId = undefined;
if (data.response.shipment.return_request_id) {
returnRequestId = data.response.shipment.return_request_id;
}else{
returnRequestId = undefined;
}

const parts = delaystatustext.split(/(within|by| in| on)/);
const arrivingBy = (parts[0] + (parts[1] ?? '')).trim();
const dateInfo = parts[2] ? parts[2].trim() : "";

let statusClass = '';
let statusImage = '';
if (delaystatustime.toLowerCase() === 'on time') {
statusClass = 'on-time';
statusImage = '<img src="https://cdn.shopify.com/s/files/1/0565/8021/0861/files/ontime.png?v=1729676281" alt="On Time" width="16" height="16">'; 

} 
else if (delaystatustime.toLowerCase() === 'early delivery') {
statusClass = 'early-delivery';
statusImage = '<img src="https://cdn.shopify.com/s/files/1/0565/8021/0861/files/bitcoin-icons_rocket-filled.png?v=1732016833" alt="On Time" width="16" height="16">'; 

} 

delaystatusTextQuickDelivery.innerHTML = `
<span class="arriving-text-quick-delivery">${arrivingBy}</span>
<span class="date-text-quick-delivery">${dateInfo ?? ''}</span>
<div class="delivery-status-label-quick-delivery statusClass ${statusClass}">
 <span class="status-text-quick-delivery">${delaystatustime}</span>
</div>
`;

delaystatusDiv.innerHTML = `
<span class="arriving-text">${arrivingBy}</span> 
<span class="date-text">${dateInfo ?? ''}</span>
<div class="delivery-status-label statusClass ${statusClass}">
 <span class="status-text">${delaystatustime}</span>
</div>
`;
deliveredTextDiv.innerHTML = `
<span class="arriving-text">${arrivingBy}</span> 

<span class="date-text">${dateInfo ?? ''}</span>

`;

if (isOCDeliveryOrder == true){
  document.querySelector('.circle-mweb').style.width = '155px';
  document.querySelector('.circle-mweb').style.height = '155px';
arrivingtextmweb.innerHTML = `
<div class="arriving-text-quick-delivery">
<h1>${arrivingBy}</h1>
<h2>${dateInfo}</h2> 
</div>
`;
}
else{
arrivingtextmweb.innerHTML = `
<h1>${arrivingBy}</h1>
<h2>${dateInfo}</h2> `;
}

deliverytext.innerHTML=`
<span>${delaystatustext}</span>
`;

const itemContainerDiv = document.querySelector('.item')


const deliveredtextmweb = orderData?.delayStatus ?? ''; 
const statusMessages = {
'DELAYED': 'Your order has been delivered',
'EARLY DELIVERY': 'Yayy! Order delivered early',
'ON TIME': 'Your order arrived just on time!'
};

if (deliveredtextmweb.toLowerCase() === 'early delivery') {
document.querySelector('.delivered-text svg').style.display = 'block';
}

const statusMessageElement = document.getElementById('delivered-text-mweb');
const addressElement = document.getElementById('delivered-address-mweb');

addressElement.textContent = data.response.deliveryAddress;
addressElement.classList.add('truncate-1-lines');


if (deliveredtextmweb && statusMessages[deliveredtextmweb]) {
statusMessageElement.textContent = statusMessages[deliveredtextmweb];
} else {
statusMessageElement.textContent = 'Order status unknown';
}
const paymentMode = orderData?.paymentMode ?? '';
if (paymentMode.toLowerCase() === 'cod') {
const paymentMessageDiv = document.getElementById('paymentMessage');
if (orderData.status.toLowerCase() === 'refunded' ) {
  paymentMessageDiv.innerHTML = `
 <div class="text-section">
     <p class="payment-amount">A refund of  <span class="text-section-amount">&#8377;${Math.round(orderData?.total)}</span> has been processed Successfully</p>
 </div>`;
}
else {
  if (orderData.total > 1){
        paymentMessageDiv.innerHTML = `
        <div class="text-section">
              <p class="payment-amount">Payment of  <span class="text-section-amount">&#8377;${Math.round(orderData.total)}</span> pending</p>
              <span class="payment-note">Pay in cash at the time of delivery</span>
        </div>`;  
  }    
}
}else {
paymentContainerDiv.style.display = 'none';
}
const itemDiv = document.querySelector('.items_details_cont');


data.response.shipment.line_items.forEach(item => {
const itemDetails = document.createElement('div');
itemDetails.classList.add('item-details-text');

itemDetails.innerHTML = `
<div style="display: flex; width: 100%;">
<div class="item-img">
  <img src="${item.image_url}" alt="${item.title}"/>
  ${item.quantity > 1 ? `<div class="item-quantity-details">x${item.quantity}</div>` : ''}
</div>
<div class="item-title-text">
<h2 class="truncate-1-lines">${item?.title}</h2>
<p>Size: ${item.variantTitle}</p>
</div>
</div>
<div class="item-price" style="width: 30%">
<h5>₹${Math.round(item.price)}</h5>
<p>MRP ₹${Math.round(item.compareAtPrice)}</p>
</div>
`;

itemDiv?.appendChild(itemDetails);
});

const cancellablebtn = data.response.cancellable;
const cancelOrderSpan = document.getElementById('cancelOrderSpan');
if (cancellablebtn) {                
cancelSection.querySelector('p').textContent = "Want to cancel your order?";
cancelOrderSpan.style.display = 'block'; 
}
else {
document.getElementById('cancel-container').innerHTML = '';
const cancellationCopy = window.shipmentDetailsData?.cancellationCopy || "Your order can't be cancelled.";
document.getElementById('cancel-container').innerHTML = `
<div class="cancel-text-new">
<h1><span>Note:</span> ${cancellationCopy}</h1>
<a onclick="window.open('https://supertails.com/policies/refund-policy', '_blank')">Read Cancellation policy</a>
</div>
`;
}

document.querySelector('.address-cont p').innerText = data.response?.deliveryAddress;
const orderId=data.response.orderName;
const orderName= document.getElementById('order-name');
orderName.innerHTML = `${orderId}`;

const amount=Math.round(orderData.total);
const amountvalue = document.getElementById(`order-value`);
if (paymentMode.toLowerCase() === 'cod') {
amountvalue.innerHTML = `₹${amount} via COD`;
}
else {
amountvalue.innerHTML = `₹${amount} via UPI`;
}
const callUsButton = document.querySelector('.need-help-details');
if (callUsButton) {
callUsButton.addEventListener('click', function() {
window.location.href = 'tel:+919187711456';
});
}
const orderDate=orderData.orderDate;
const date = new Date(data.response.orderDate);
const day = String(date.getDate()).padStart(2, '0'); 
const month = String(date.getMonth() + 1).padStart(2, '0'); 
const year = date.getFullYear();
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const ordermonth = months[date.getMonth()]; 
const formattedDate = `${day} ${ordermonth}, ${year}`;
const dateElement = document.getElementById('order-date');
dateElement.innerHTML = formattedDate;
const singleShipment = document.querySelector('.item_details_container');
const multipleShipment = document.querySelector('.items-section');

if (totalShipments > 1 || orderData?.line_items?.length > 1) {
multipleShipment.style.display = 'block';
}
else {
singleShipment.style.display = 'block';
document.querySelectorAll('.view-return-container').forEach(element => element.style.borderTop = 'solid 0.6px #E7E8E8');
}

function extractProductId(gid) {
const parts = gid.split('/');
return parts[parts.length - 1];
}
const maxVisibleItems = 3;  
let isExpanded = false;

function renderItems() {
itemContainerDiv.innerHTML = ""; // Clear

const visibleItems = isExpanded ? itemImage : itemImage.slice(0, maxVisibleItems);

visibleItems.forEach(item => {
const itemLink = document.createElement('a');
const link = (item?.variant?.product?.onlineStorePreviewUrl ?? "") + "?variantId=" + extractProductId(item?.variant?.id);

if (link?.[0] !== "?") {
  itemLink.href = link;
  itemLink.classList.add('item-link');
}



const itemImageDiv = document.createElement('div');
const itemQtyDiv = document.createElement('div');
const itemNameDiv = document.createElement('div');
const itemNameAndImageDiv = document.createElement('div');
const itemPriceDiv = document.createElement('div');

itemImageDiv.classList.add('image-box');
itemQtyDiv.classList.add('item-quantity');
itemNameDiv.classList.add('item-name', 'truncate-1-lines');
itemNameAndImageDiv.classList.add('item-name-and-image');
itemPriceDiv.classList.add('item-price-new');

itemImageDiv.innerHTML = `<img src="${item.image_url || ''}" loading="lazy">`;
itemNameDiv.innerHTML = `<p>${item?.quantity > 1 ? `${item.quantity}x ` : ''} ${item.name}</p>`;
itemPriceDiv.innerHTML = `<p>₹${Math.round(item.price, 0)}</p>`;

if (item?.quantity > 1) {
  itemQtyDiv.textContent = `x${item.quantity}`;
  itemImageDiv.appendChild(itemQtyDiv);
}

if (
  ["return requested", "return approved", "return item picked up", "refunded"]
  .includes(orderData.status.toLowerCase())
) {
  const returnText = document.createElement('div');

  if (item?.returnStatus && item?.returnStatus !== "undefined") {
     itemImageDiv.classList.add('returned-item');
     returnText.classList.add('return-text');
     returnText.innerHTML = `<p>${item?.returnStatus ?? ''}</p>`;
  }

  if (item?.returnedQuantity > 1) {
     itemQtyDiv.textContent = `x${item?.returnedQuantity}`;
     itemQtyDiv.classList.add('return-quantity');
  }

  itemImageDiv.appendChild(returnText);
}

itemNameAndImageDiv.appendChild(itemImageDiv);
itemNameAndImageDiv.appendChild(itemNameDiv);
itemLink.appendChild(itemNameAndImageDiv);
itemLink.appendChild(itemPriceDiv);

itemContainerDiv.appendChild(itemLink);
});

const remainingItems = itemImage.length - maxVisibleItems;

if (itemImage.length > maxVisibleItems) {
const btn = document.createElement('button');
btn.classList.add("more-items-btn");

if (!isExpanded) {
  btn.textContent = `& ${remainingItems} more`;
  btn.onclick = () => {
     isExpanded = true;
     renderItems();
  };
} else {
  btn.textContent = "View less";
  btn.onclick = () => {
     isExpanded = false;
     renderItems();
  };
}

itemContainerDiv.appendChild(btn);
}
}

renderItems();

timestatusMweb.innerHTML = ` 
<div class="delivery-status-label statusClass ${statusClass}">
${statusImage}
<span class="status-text">${delaystatustime}</span>
</div>
`; 


})
.catch(error => {
  const loaderElement = document.getElementById('loader_123');
  if (loaderElement) {
    loaderElement.style.display = "flex";
    loaderElement.innerHTML = "<p>Try Again</p>";
  }
  console.error('Error fetching shipment details:', error);
});


const referrerUrl = window.location.href; // Use referrer or fallback to "#"

function backRedirection() {
if(sessionStorage.getItem('viewdetailsredirection')) {
const viewdetailsredirection = sessionStorage.getItem('viewdetailsredirection');
window.location.href = viewdetailsredirection;
} else {
window.location.href = 'https://supertails.com/account';
}
}

// ===== RESCHEDULE SCRIPT =====

document.addEventListener("DOMContentLoaded", function () {
        
         const modalReschedule = document.getElementById('myModalReschedule');
         const modalcontent = document.getElementById("modalContentReschedule");
         const modalBtnReschedule = document.getElementById('reschedule-btn');
         const closeBtnReschedule = document.getElementById('closeReschedule');
         const rescheduleBtn = document.getElementById("reschedule-btn-modal");
         const rescheduleFormContent = document.getElementById("rescheduleFormContent");
         const cancelBtn = document.getElementById("cancel-btn");
         const backArrow = document.getElementById("backArrow");
         const rescheduleBtnBox = document.getElementById("rescheduleOptionsContainer");
         const rescheduleBtnConfirm = document.getElementById("reschedule-confirm-btn");
         const rescheduledBoxConfirm = document.getElementById("rescheduledBoxConfirm");
         const reviewSection = document.getElementById("review-section");
         const reviewSectionPhone = document.getElementById("review-section-phone");
         const reviewSectionAddress1 = document.getElementById("review-section-address-1");
         const reviewSectionComplete = document.getElementById("review-section-complete");
         const rescheduleTextInfo = document.getElementById("reschedule-text-info");
         const returnButtonNew = document.querySelectorAll('#return-items-new');
         const queryString = window.location.search;
         const urlParams = new URLSearchParams(queryString);
         const orderIdNew = urlParams.get('orderId')
         let cpId = ''
         let awb = ''
         let accountcode
         const crossbutton = document.getElementById("crossReschedule");

         crossbutton?.addEventListener("click", function () {
           rescheduleFormContent.style.display = "none";
           rescheduleBtnBox.style.display = "flex";
           document.getElementById("review-section-btn").style.display = "none";
           reviewSectionComplete.style.display = "none";

           backArrow.style.display = "none";
           closeModal();
           if (modalcontent && window.innerWidth <= 575) 
              modalcontent.style.height = "";
           });

        if (returnButtonNew && returnButtonNew.length > 0) {
          returnButtonNew.forEach(button => button.addEventListener("click", function () {
            const shipmentItems = [];
            if (typeof returnRequestId === "undefined"){
                window.location.replace(`https://supertails.com/pages/return-request?orderId=${orderIdNew}&awb=${awb1}`)
            }
            else{
                window.location.replace(`https://supertails.com/pages/return-request?orderId=${orderIdNew}&awb=${awb1}&returnRequestId=${returnRequestId}`)
            }
          }));
        }
     
         let scrollPosition = 0;
           function openModal() {
           scrollPosition = window.pageYOffset;
           document.body.classList.add('modal-open');
           document.body.style.top = `-${scrollPosition}px`;
           modalReschedule.style.display = 'flex';
        }
     
        function closeModal() {
           document.body.classList.remove('modal-open');
           document.body.style.top = '';
           window.scrollTo(0, scrollPosition);
           modalReschedule.style.display = 'none';
        }
         modalBtnReschedule.onclick = function () {
             modalReschedule.style.display = 'block';
             openModal();
     
         };
         //closeBtnReschedule.onclick = 
         cancelBtn.onclick = function () {
             let ndrStatusResponse = [];
             let status_code = "";
             const ndrStatusApi = `https://supertails-backend.el.r.appspot.com/order/post-order/ndr-status/web?awb=${awb1}`;
             const cancelUrl = 'https://supertails-backend.el.r.appspot.com/order/post-order/reschedule-delivery/web';
             fetch(ndrStatusApi)
                 .then(response => response.json())
                 .then(data => {
                     ndrStatusResponse = data.response;
                     cpId = ndrStatusResponse?.cp_id;
                     accountcode = ndrStatusResponse?.account_code;
                     awb = ndrStatusResponse?.awb;
                     status_code = ndrStatusResponse?.ndr_status_code;

                     const formData = {
                                action: "INITIATE_RTO",
                                 waybill: awb,
                                 cp_id: cpId,
                                 account_code: accountcode,
                             };
                       fetch(cancelUrl, {
                                 method: "POST",
                                 headers: { 'Content-Type': 'application/json' },
                                 body: JSON.stringify(formData)
                             })
                             .then(response => response.json())
                             .then(data => {})
                             .catch(error => {});
                             rescheduleFormContent.style.display = "none";
                             closeModal();
                             document.getElementById("reschedule-btn").style.display = "none";
                             document.querySelector('.rescheduled-text').textContent = "We are trying to cancel your order. Otherwise, you can reject it at the time of delivery";

                 })
                 .catch(error => {});                
         };
                closeBtnReschedule?.addEventListener("click", function () {
                 rescheduleFormContent.style.display = "none";
                 rescheduleBtnBox.style.display = "flex";
                 document.getElementById("review-section-btn").style.display = "none";
                 reviewSectionComplete.style.display = "none";

                 backArrow.style.display = "none";

                 closeModal();
                 if (modalcontent && window.innerWidth <= 575) 
                    modalcontent.style.height = "";
                 });
     
         rescheduleBtn?.addEventListener("click", function () {
             rescheduleFormContent.style.display = "block";
             rescheduleBtnBox.style.display = "none";
             backArrow.style.display = "inline-block";
             document.getElementById("review-section-btn").style.display = "block";
             if (modalcontent && window.innerWidth <= 575) 
                    modalcontent.style.height = "100%";
             let ndrStatusResponse = [];
             const ndrStatusApi = `https://supertails-backend.el.r.appspot.com/order/post-order/ndr-status/web?awb=${awb1}`;
     
             fetch(ndrStatusApi)
                 .then(response => response.json())
                 .then(data => {
                     ndrStatusResponse = data.response;
                     cpId = ndrStatusResponse?.cp_id;
                     accountcode = ndrStatusResponse?.account_code;
                     awb = ndrStatusResponse?.awb;
                     const status_code = ndrStatusResponse?.ndr_status_code;

                     if (status_code === 5) {
                         reviewSectionPhone.style.display = "block";
                     } else if (status_code === 6 || status_code === 8 || status_code === 9) {
                         reviewSectionAddress1.style.display = "block";
                     } else {
                         rescheduleTextInfo.style.display = "block";
                         reviewSection.style.display = "block";
                     }
     
                     const addressInput = document.querySelector('#review-section-address-1 .address-line');
                     const landmarkInput = document.querySelector('#review-section-address-1 .Landmark');
                     const phoneInput = document.querySelector('#review-section-phone .phone-number');
                     let phoneNumberValue = '';
                     let addressValue = '';
                     let landmarkValue = '';
                     let textAreaValue = '';
                     const storedPincode = localStorage.getItem('pincode');

     
                     phoneInput?.addEventListener('input', (event) => {
                       let value = event.target.value.replace(/\D/g, '');
                          value = value.substring(0, 10);
                          event.target.value = value;
                         phoneNumberValue = value;
                     });
     
                     phoneInput?.addEventListener('focus', () => {
                         document.querySelector('.floating-text-mobile').style.display = 'block';
                     });
     
                     phoneInput?.addEventListener('blur', () => {
                         if (!phoneInput.value) {
                             document.querySelector('.floating-text-mobile').style.display = 'none';
                         }
                     });
     
                     addressInput?.addEventListener('input', (event) => {
                         addressValue = event.target.value;
                     });
                     addressInput?.addEventListener('focus', () => {
                         document.querySelector('.floating-text-mobile').style.display = 'block';
                     });
     
                     addressInput?.addEventListener('blur', () => {
                         if (!addressInput.value) {
                             document.querySelector('.floating-text-mobile').style.display = 'none';
                         }
                     });
                     rescheduleBtnConfirm.disabled = true;
     
                     document.getElementById('review-textArea')?.addEventListener('input', function (event) {
                       textAreaValue = event.target.value.trim();  // trim any extra spaces
                       rescheduleBtnConfirm.disabled = textAreaValue === "";
     
                         
                     });
     
                     landmarkInput?.addEventListener('input', (event) => {
                         landmarkValue = event.target.value;
                     });
     
                     const rescheduleDeliveryOptions = document.getElementById('reschedule-date-options');
                     rescheduleDeliveryOptions?.addEventListener("click", (e) => {
                         if (e.target.tagName === "BUTTON") {
                             document.querySelectorAll('#reschedule-date-options button').forEach(btn => btn.classList.remove('selected'));
                             e.target.classList.add('selected');
     
                         }
                     });
                     let formData = {};
                     rescheduleBtnConfirm?.addEventListener("click", () => {
                         const selectedButton = document.querySelector("#reschedule-date-options button.selected");
                         
                         if (selectedButton) {
                          const labelValue = selectedButton.getAttribute("data-date") || selectedButton.textContent;
                          const rescheduleUrl = 'https://supertails-backend.el.r.appspot.com/order/post-order/reschedule-delivery/web';

                          const getPreferredDate = () => {
                             const today = new Date();
                             const currentDay = today.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

                             const daysOfWeek = {
                                Sunday: 0,
                                Monday: 1,
                                Tuesday: 2,
                                Wednesday: 3,
                                Thursday: 4,
                                Friday: 5,
                                Saturday: 6,
                             };

                             
                             const labelDay = labelValue.split(',')[0].trim();
                             const targetDay = daysOfWeek[labelDay]; 

                           
                             let daysToAdd = targetDay - currentDay;
                             if (daysToAdd < 0) {
                                daysToAdd += 7; 
                             }

                             
                             const preferredDate = new Date(today);
                             preferredDate.setDate(today.getDate() + daysToAdd);

                             
                             return preferredDate.toISOString().split('T')[0];
                             };
                          if (status_code === 5) {
                             formData = {
                                action: "REATTEMPT",
                                 waybill: awb,
                                 cp_id: cpId,
                                 phone_number: phoneNumberValue || "",
                                 preferred_date: getPreferredDate() || "",
                                 account_code: accountcode,
                                 drop_pincode: storedPincode,
                             };
                          } else if (status_code === 6 || status_code === 8 || status_code === 9) {
                             formData = {
                                 action: "REATTEMPT",
                                 waybill: awb,
                                 cp_id: cpId,
                                 address: addressValue || "",
                                 preferred_date: getPreferredDate() || "",
                                 account_code: accountcode,
                                 drop_pincode: storedPincode,
                             };
                          } else {
                             formData = {
                                action: "REATTEMPT",
                                 waybill: awb,
                                 cp_id: cpId,
                                 preferred_date: getPreferredDate() || "",
                                 comment: textAreaValue || "",
                                 account_code: accountcode,
                                 drop_pincode: storedPincode,
                             };
                          }
     
                             fetch(rescheduleUrl, {
                                 method: "POST",
                                 headers: { 'Content-Type': 'application/json' },
                                 body: JSON.stringify(formData)
                             })
                             .then(response => response.json())
                             .then(data => {})
                             .catch(error => {});
                         } else {
                         }
                     });
                 })
                 .catch(error => {});
         });
     
         backArrow?.addEventListener("click", function () {
             rescheduleFormContent.style.display = "none";
             rescheduleBtnBox.style.display = "flex";
             document.getElementById("review-section-btn").style.display = "none";
             reviewSectionComplete.style.display = "none";

             backArrow.style.display = "none";
           if (modalcontent && window.innerWidth <= 575) 
              modalcontent.style.height = "";
         });
     
         
         if (rescheduleBtnConfirm) {
             rescheduleBtnConfirm.addEventListener("click", function () {
                 if (rescheduleBtnConfirm.innerText === "Reschedule delivery") {
                   
                     rescheduleBtnConfirm.innerText = "Confirm";
                     reviewSection.style.display = "none";
                     reviewSectionPhone.style.display = "none";
                     reviewSectionAddress1.style.display = "none";
                     rescheduleTextInfo.style.display = "none";
                     reviewSectionComplete.style.display = "block";
                 } else if (rescheduleBtnConfirm.innerText === "Confirm") {
                     modalReschedule.style.display = 'none';
                     closeModal();
                     rescheduledBoxConfirm.style.display = "flex";
                     document.getElementById("rescheduledBox").style.display = "none";
                 }
             });
         } else {
             console.error("Reschedule confirm button not found!");
         }
     });

// ===== TIMELINE SCRIPT =====

if (document.querySelector(".trackingid-text")) {
     document.querySelector(".trackingid-text").textContent = awb1;
     const trackingApiUrl = `https://supertails-backend.el.r.appspot.com/order/post-order/shipment/journey/web?awb=${awb1
     ?? ''}&orderId=${orderId1}`;
      let statusResponse= [];
     fetch(trackingApiUrl)
         .then(response => response.json())
         .then(data => {
             statusResponse = data.response;
             createTimeline();
         })
         .catch(error => {
         });
     
     
         const getStatusText = (statusCode) => {
             
     switch (parseInt(statusCode)) {
     case 1:
       return 'Your order has been confirmed';
     case 4:
       return 'Your items have been shipped';
     case 5:
       return 'Your items are on their way';
     case 6:
       return 'Your items are out for delivery';
     case 8:
       return 'Your items have been delivered';
     case 9:
       return 'Your items could not be delivered';
     case 12:
       return 'Your items have been returned to supertails';
     case 1004:
       return 'Your items have reached the nearest warehouse';
     
     default:
       return 'Your items have been returned to supertails';
     }
     };
     const createTimeline = () => {
     const timelineContainer = document.querySelector('.timeline');
     statusResponse.reverse().forEach((item,index) => {
     const setDiv = document.createElement('div');
     setDiv.classList.add('set');
     
   
     const timeDiv = document.createElement('div');
     timeDiv.classList.add('time');
     const timestampStr = item.timestamp;
     
     const dateObj = new Date(timestampStr);
     const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
     const month = monthNames[dateObj.getUTCMonth()];
     const day = String(dateObj.getUTCDate()).padStart(2, '0');
     const hours = String(dateObj.getUTCHours()).padStart(2, '0');
     const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
     const formattedDate = `${month}-${day}`;
     const formattedTime = `${hours}:${minutes}`;
     timeDiv.innerHTML = `<span class="tracking-time">${formattedTime}</span>
     <span class="tracking-date">${formattedDate}</span>`;
     
     
     const vStepperDiv = document.createElement('div');
     vStepperDiv.classList.add('v-stepper');
     const circleDiv = document.createElement('div');
     circleDiv.classList.add('circle');
     if (index === 0) {
       if (item.status_code === '9') {
         circleDiv.classList.add('cancelc');
       } 
       else if (item.status_code === '1' || 
                 item.status_code === '4' ||
                 item.status_code === '5' ||
                 item.status_code === '6' ||
                 item.status_code === '8' ||
                 item.status_code === '1004') {
         circleDiv.classList.add('check-icon');
       }
       else{
        circleDiv.classList.add('returnedS');
       }
     }
     if (item.status_code === '9') {
       circleDiv.classList.add('cancelc'); 
     }
     
     const lineDiv = document.createElement('div');
     lineDiv.classList.add('line');
     if (item.status_code === '9') {
       lineDiv.classList.add('cancel-line'); 
     }
     else if (item.status_code === '1' || 
                 item.status_code === '4' ||
                 item.status_code === '5' ||
                 item.status_code === '6' ||
                 item.status_code === '8' ||
                 item.status_code === '1004') {
         lineDiv.classList.add('curr-line');
       }
     else{
        lineDiv.classList.add('cancel-line');
     }
     
     
     vStepperDiv?.appendChild(circleDiv);
     if (index !== statusResponse.length - 1) {
         vStepperDiv?.appendChild(lineDiv);
         }
     
     
     const statusDiv = document.createElement('div');
     statusDiv.classList.add('status');
     const locationText = item.scan_location ? `(${item.scan_location})` : '';
     statusDiv.innerHTML = `<h1>${getStatusText(item.status_code)}</h1><h2 class="truncate-1-lines">${locationText}</h2>`;
     
     
     setDiv?.appendChild(timeDiv);
     setDiv?.appendChild(vStepperDiv);
     setDiv?.appendChild(statusDiv);
     timelineContainer?.appendChild(setDiv);
     });
     };
     
     
     
     
     
    
     document.getElementById("modal-btn").addEventListener("click", function() {
     document.getElementById("myModal").style.display = "flex";
     document.body.style.overflow = "hidden";
     });

     
     document.getElementById("close").addEventListener("click", function() {
     document.getElementById("myModal").style.display = "none";
     document.body.style.overflow = "";
     });

     
     window.addEventListener("click", function(event) {
     const modal = document.getElementById("myModal");
     const modalContent = document.querySelector(".tracking-cont");

     if (event.target === modal) {
        modal.style.display = "none";
        document.body.style.overflow = "";
     }
     });
  }

// ===== ACCOUNT MANAGEMENT SCRIPT =====

const orderDiv = document.getElementsByClassName('hideOrders');
const hiddenOrders = orderDiv.length;
let ordersNeedToBeShown = orderDiv.length;
let ordersShown = 0;
const addressCard = document.getElementsByClassName('hideAddress');
const hiddenAddresses = addressCard.length;
let addressesNeedToBeShown = addressCard.length;
let addressesShown = 0;
const activeTab = sessionStorage.getItem("activeTab")
let addressIdToDelete;
let customerIdToDeleteCustomer;

if (activeTab && activeTab != "subscription") {
if (window.innerWidth > 800) {
document.getElementsByClassName(activeTab)[0].classList.add("activeTab")
}
document.getElementsByClassName(activeTab + "Data")[0].classList.add("activeTabPanel")
document.getElementById('settings').style.display = 'none';
document.getElementById('data').style.display = 'block';
} else {
if (window.innerWidth > 800) {
document.getElementsByClassName("order")[0].classList.add("activeTab")
}
document.getElementsByClassName("orderData")[0].classList.add("activeTabPanel")
}
function handleClickOutside() {
window.location.href = "https://supertails.com/pages/contact-us";
}
function handleClick(tabName) {
window.sessionStorage.setItem("activeTab", tabName);
location.reload();
if (window.innerWidth > 800) {
document.getElementsByClassName("order")[0].classList.remove("activeTab")
document.getElementsByClassName("address")[0].classList.remove("activeTab")
document.getElementsByClassName("subscription")[0].classList.remove("activeTab")
document.getElementsByClassName("inviteFriends")[0].classList.remove("activeTab")
document.getElementsByClassName("contactUs")[0].classList.remove("activeTab")
document.getElementsByClassName("accountSettings")[0].classList.remove("activeTab")
document.getElementsByClassName("logOut")[0].classList.remove("activeTab")
document.getElementsByClassName(tabName)[0].classList.add("activeTab")
}
document.getElementsByClassName("orderData")[0].classList.remove("activeTabPanel")
document.getElementsByClassName("addressData")[0].classList.remove("activeTabPanel")
document.getElementsByClassName("subscriptionData")[0].classList.remove("activeTabPanel")
document.getElementsByClassName("inviteFriendsData")[0].classList.remove("activeTabPanel")
document.getElementsByClassName("contactUsData")[0].classList.remove("activeTabPanel")
document.getElementsByClassName("accountSettingsData")[0].classList.remove("activeTabPanel")
document.getElementsByClassName("logOutData")[0].classList.remove("activeTabPanel")
document.getElementsByClassName(tabName + "Data")[0].classList.add("activeTabPanel")
if (window.innerWidth < 800) {
document.getElementById('settings').style.display = 'none';
document.getElementById('data').style.display = 'block';
}
};

function showTabs() {
document.getElementById('settings').style.display = 'block';
document.getElementById('data').style.display = 'none';
}

function handleLoadMoreForOrders() {
let loopLength = ordersNeedToBeShown > 10 ? 10 : ordersNeedToBeShown;
for (let i = ordersShown; i < ordersShown + loopLength; i++) {
orderDiv[i].style.display = "block";
}
ordersNeedToBeShown = ordersNeedToBeShown - 10;
ordersShown = ordersShown + 10;
if (ordersNeedToBeShown <= 0) {
document.getElementById('loadMore').style.display = "none"
}
}

function showFilters() {
document.getElementsByClassName("filterOrders")[0].classList.toggle("hide");
}

function hideFilters() {
document.getElementsByClassName("filterOrders")[0].classList.toggle("hide");
}

function showSaveButton(id) {
document.getElementById(`submit_button_${id}`).classList.toggle("hide")
}

function handleLoadMoreForAddresses() {
let loopLength = addressesNeedToBeShown > 10 ? 10 : addressesNeedToBeShown;
for (let i = addressesShown; i < addressesShown + loopLength; i++) {
addressCard[i].style.display = "block";
}
addressesNeedToBeShown = addressesNeedToBeShown - 10;
addressesShown = addressesShown + 10;
if (addressesNeedToBeShown <= 0) {
document.getElementById('loadMoreForAddress').style.display = "none"
}
}

function editName(fullName) {
document.getElementsByClassName('nameCard')[0].classList.toggle("hide");
document.getElementsByClassName('editName')[0].classList.toggle("hide");
document.getElementsByClassName('saveAccountDetails')[0].classList.remove("hide");
document.getElementById("customerName").value = fullName;
}

function handleNameChange(id) {
const name = document.getElementById("customerName").value;
const fullName = name.split(" ");
const lastName = fullName[fullName.length - 1];
fullName.pop();
const firstName = fullName.join(" ");
const finalFirstName = encodeURI(firstName)
fetch(`https://servicereminder.el.r.appspot.com/UpdatetCustomerName?id=${id},fName=${finalFirstName}&lName=${lastName}`)
.then(() => {
document.getElementsByClassName('fullName')[0].innerHTML = firstName + " " + lastName;
document.getElementsByClassName('nameCard')[0].classList.toggle("hide");
document.getElementsByClassName('editName')[0].classList.toggle("hide");
document.getElementsByClassName('saveAccountDetails')[0].classList.toggle("hide");
location.reload()
})
}

function setupCountries() {
setTimeout(() => {
if (Shopify && Shopify.CountryProvinceSelector) {
new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
 hideElement: 'AddressProvinceContainerNew'
});
document.querySelectorAll(".addressCountry").forEach((select) => {
 const formId = select.dataset.id;
 new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
   hideElement: `AddressProvinceContainer_${formId}`
 });
});
}
}, 1000)
}

setupCountries()

function addNewAddress(id) {
let newAddressName = document.getElementById("newAddressName").value
let newEmail = document.getElementById("newEmail").value
let newAddress1 = document.getElementById("newAddress1").value
let newAddress2 = document.getElementById("newAddress2").value
let newAddress3 = document.getElementById("newAddress3").value
let newAddressCity = document.getElementById("newAddressCity").value
let newAddressCountry = document.getElementById("AddressCountryNew").value
let newAddressProvince = document.getElementById("AddressProvinceNew").value
let newAddressZip = document.getElementById("newAddressZip").value
let newAddressDefault = document.getElementById("newAddressDefault").checked
let newPhone = document.getElementById('newaddPhoneNumber').value
const newAddress = {
address: {
address: {
 address1: newAddress1,
 address2: `${newAddress2} Landmark - ${newAddress3}`,
 city: newAddressCity,
 province: newAddressProvince,
 country: newAddressCountry,
 zip: newAddressZip,
 name: newAddressName,
 phone: newPhone,
 email: newEmail,
 country_name: newAddressCountry
}
},
"cId": id,
"isDefault": newAddressDefault
}
fetch('https://servicereminder.el.r.appspot.com/addCustomerAddress', {
method: 'POST',
body: JSON.stringify(newAddress),
headers: {
'Content-type': 'application/json',
}
})
.then((res) => {
if (res.status === 200) {
 location.reload();
}
})
.then((data) => {
})
.finally(() => {
document.getElementById("AddressNewForm").classList.toggle("hide");
})
}

function showAddNewAddress() {
document.getElementById("AddressNewForm").classList.toggle("hide");
}

function hideAddNewAddress() {
document.getElementById("AddressNewForm").classList.toggle("hide");
}

function showEditAddress(id) {
document.getElementById(`editAddressForm_${id}`).classList.toggle("hide");
}

function hideEditAddress(id) {
document.getElementById(`editAddressForm_${id}`).classList.toggle("hide");
}

function deleteAddress(id, cid) {
addressIdToDelete = id;
customerIdToDeleteCustomer = cid;
document.getElementsByClassName('deleteAddressForm')[0].classList.toggle("hide");
}

function confirmDeleteAddress() {
fetch(`https://servicereminder.el.r.appspot.com/deleteCustomerAddress?cId=${customerIdToDeleteCustomer}&aId=${addressIdToDelete}`)
.then((res) => {
if (res.status === 200) {
 location.reload();
}
})
.finally(() => {
document.getElementsByClassName('deleteAddressForm')[0].classList.toggle("hide");
})
}

function expandAccordion(id) {
if (document.getElementById(id).style.maxHeight != "1000px") {
document.querySelectorAll(".heading").forEach((element) => {
element.style.maxHeight = "0px"
})
document.querySelectorAll(".expand").forEach((element) => {
element.setAttribute("d", "M6 12H18M12 18V6");
})
const parentElement = document.getElementById(id).parentElement
parentElement.children[0].children[0].children[0].setAttribute("d", "M6 12H18")
document.getElementById(id).style.maxHeight = "1000px"
} else {
const parentElement = document.getElementById(id).parentElement
parentElement.children[0].children[0].children[0].setAttribute("d", "M6 12H18M12 18V6")
document.getElementById(id).style.maxHeight = "0px"
}
}

function showHeadingContent(id) {
if (document.getElementById(id).style.maxHeight != "1000px") {
document.querySelectorAll(".headingContent").forEach((element) => {
element.style.maxHeight = "0px"
})
document.querySelectorAll(".arrowRightIcon").forEach((element) => {
element.style.rotate = "0deg"
})
document.getElementById(id).style.maxHeight = "1000px"
const parentElement = document.getElementById(id).parentElement
parentElement.children[0].children[0].style.rotate = "90deg";
} else {
document.getElementById(id).style.maxHeight = "0px"
const parentElement = document.getElementById(id).parentElement
parentElement.children[0].children[0].style.rotate = "0deg";
}
}

function inviteLink() {
document.getElementById('inviteLink').value = "https://supertails.com/"
let postUrl = encodeURI("https://supertails.com/");
let postTitle = encodeURI("Welcome to Supertails!");
let postSummary = encodeURI("Thanks for sharing Supertails");
document.getElementsByClassName("whatsApp")[0] && (document.getElementsByClassName("whatsApp")[0].setAttribute("href", `https://wa.me/?text=${postTitle} ${postUrl}`))
document.getElementsByClassName("facebook")[0].setAttribute("href", `https://www.facebook.com/sharer.php?u=${postUrl}`)
document.getElementsByClassName("linkedIn")[0].setAttribute("href", `https://www.linkedin.com/shareArticle?url=${postUrl}&title=${postTitle}&summary=${postSummary}`)
document.getElementsByClassName("twitter")[0].setAttribute("href", `https://twitter.com/share?url=${postUrl}&text=${postTitle}`)
}

inviteLink()

function copyInviteLink() {
let inviteLink = document.getElementById('inviteLink').value;
navigator.clipboard.writeText(inviteLink)
.then(() => {
document.getElementById("copied-label").innerHTML = 'Copied!';
document.getElementsByClassName("copied-label-svg").style.display = "none";
setTimeout(() => {
 document.getElementById("copied-label").innerHTML = 'Copy link';
 document.getElementsByClassName("copied-label-svg").style.display = "block";
}, 1000)
})
}

function showShareButton() {
if (!navigator.share) {
document.getElementsByClassName("shareButton")[0].classList.add("hide");
}
}

showShareButton()

function shareInvite() {
navigator.share({
title: 'Welcome to Supertails',
url: 'https://supertails.com/'
}).then(() => {
})
}

function showAccordian(id, parentId) {
let element = document.getElementById(id + "Desktop");
let parentElement = document.getElementsByClassName('headings')[0].children[parentId]
if (!element.classList.value.includes("hide")) {
element.classList.toggle("hide")
parentElement.classList.toggle("active")
} else {
document.querySelectorAll(".retaledQuestions").forEach((element) => {
element.classList.add("hide")
})
document.querySelectorAll(".active").forEach((element) => {
element.classList.remove("active")
})
element.classList.toggle("hide")
parentElement.classList.toggle("active")
}
}

function openContent(id) {
let element = document.getElementById(id);
if (element.style.maxHeight === "1000px") {
element.style.maxHeight = "0px"
element.parentElement.children[0].children[0].style.rotate = "0deg"
} else {
document.querySelectorAll(".content").forEach((element) => {
element.style.maxHeight = "0px"
})
document.querySelectorAll(".arrowIcon").forEach((element) => {
element.style.rotate = "0deg"
})
element.style.maxHeight = "1000px"
element.parentElement.children[0].children[0].style.rotate = "90deg"
}
}